module.exports = __webpack_public_path__ + "static/img/privacy-3.ec3f551.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-3.png
// module id = 1511
// module chunks = 1